import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"

export type PageContentProps = ComponentProps<"div">

function PageContent(props: PageContentProps) {
  const { className, ...divProps } = props
  return <div className={cn("page-content", className)} {...divProps} />
}

export default PageContent
